



























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import { IContentSet } from "../../../models/interfaces/content/content-set.model.interface";
import { IMultivariateBasis } from "../../../models/interfaces/multivariate/multivariate-basis.model.interface";
import { IMultivariateBehaviour } from "../../../models/interfaces/multivariate/multivariate-behaviour.model.interface";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { ContentSetVersionModel } from "../../../models/content/content-set-version.model";
import container from "../../../inversify.config";
import SuccessMessage from "@/components/SuccessMessage.vue";
import { IMultivariateConfigurationRequest } from "../../../models/interfaces/multivariate/multivariate-configuration-request.model.interface";

const ContentSetVersionModule = namespace("contentSetVersionModule");
const MultivariateModule = namespace("multivariateModule");

@Component({
  components: {
    SuccessMessage
  }
})
export default class MultivariateSettings extends Vue {
  @MultivariateModule.Action public retrieveMultivariates;
  @MultivariateModule.Getter public baseis;
  @MultivariateModule.Getter public behaviours;
  @ContentSetVersionModule.Action public updateMultivariateConfig;

  get getContentSetVersion(): IContentSetVersion {
    return this.contentSetVersion;
  }

  @Prop() public contentSetVersion: IContentSetVersion;

  @Provide() public multivariateBaseisConfig: number = 0;

  @Provide() public multivariateBehaviourConfig: number = 0;

  @Provide() public testBasisOptions = [];

  @Provide() public testBehaviourOptions = [];

  private lastSaved: Date | null = null;

  @Watch("getContentSetVersion.contentSetVersionId")
  public onContentSetUpdate() {
    this.populateOptions();
  }

  public populateOptions() {
    this.retrieveMultivariates().then((result) => {
      this.testBasisOptions = this.baseis.map((val) => ({
        value: val.type,
        text: val.description
      }));
      this.testBehaviourOptions = this.behaviours.map((val) => ({
        value: val.type,
        text: val.description
      }));

      if (this.contentSetVersion) {
        this.multivariateBaseisConfig = this.contentSetVersion.multivariateBasis.type;
        this.multivariateBehaviourConfig = this.contentSetVersion.multivariateBehaviour.type;
      }
    });
  }

  public undoMultivariateChanges() {
    this.populateOptions();
  }

  public created() {
    this.populateOptions();
  }

  private submitForm() {
    if (
      this.multivariateBehaviourConfig >= 0 &&
      this.multivariateBaseisConfig >= 0
    ) {
      const model: IMultivariateConfigurationRequest = {
        behaviour: this.multivariateBehaviourConfig,
        basis: this.multivariateBaseisConfig
      };

      this.updateMultivariateConfig(model).then((result) => {
        if (result) {
          this.lastSaved = new Date();
        }
      });
    }
  }
}
